import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Question from "./pages/QuestionLadder/question";
import Leadership from "./pages/GameDLS/leadership";
import ServiceExcellence from "./pages/GameDLS/service-excellence";
import Sales from "./pages/GameDLS/sales";
import Qubisa1 from "./pages/GameDLS/qubisa1";
import Qubisa2 from "./pages/GameDLS/qubisa2";
import Cdhx1 from "./pages/GameDLS/cdhx1";
import Cdhx2 from "./pages/GameDLS/cdhx2";
import Gml1 from "./pages/GameDLS/gml1";
import Gml2 from "./pages/GameDLS/gml2";
import Login from "./pages/Login";
import RequireAuth from "./components/RequireAuth";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import VSH from "./pages/Games/vsh";
import NHIE from "./pages/Games/nhie";

const App = () => (
  <BrowserRouter>
    <Routes>
    <Route path="/question" element={<Question />} />
    <Route path="/leadership" element={<Leadership />} />
    <Route path="/service-excellence" element={<ServiceExcellence />} />
    <Route path="/cdhx-game-1" element={<Cdhx1 />} />
    <Route path="/cdhx-game-2" element={<Cdhx2 />} />
    <Route path="/qubisa-game-1" element={<Qubisa1 />} />
    <Route path="/qubisa-game-2" element={<Qubisa2 />} />
    <Route path="/gml-game-1" element={<Gml1 />} />
    <Route path="/gml-game-2" element={<Gml2 />} />
    <Route path="/sales" element={<Sales />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/vsh/:id/:id2" element={<VSH />} />
        <Route path="/nhie/:id" element={<NHIE />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
